__turbopack_context__.v({
  "avatarBlur": "OrganizerBannerBackground-module-scss-module__bTPW2a__avatarBlur",
  "coverImage": "OrganizerBannerBackground-module-scss-module__bTPW2a__coverImage",
  "root": "OrganizerBannerBackground-module-scss-module__bTPW2a__root",
});
